<template>
    <v-btn
        color="primary"
        outlined
        :loading="loading"
        @click="handleClick()"
    >
        <v-icon
            size="24"
            left
        >
            mdi-download
        </v-icon>
        {{ title }}
    </v-btn>
</template>

<script>

export default {
    name: "DownloadButton",
    props: {
        title: {
            type: String,
            default: 'Import items'
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    setup(props, ctx) {
        const handleClick = function(){
            ctx.emit('click')
        }

        return {
            handleClick,
        };
    }
};
</script>
